module.exports = __webpack_public_path__ + "static/media/logoXCel.2e305ab3.png";